import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const TrafficFlowRouteService = {
    apply: async (payload) => axios.post(API_URL + "/traffic_flow_route/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
}

export default TrafficFlowRouteService;